module.exports = __webpack_public_path__ + "odinstatic/media/cms-panel.35180de3.svg";